export const defaultColorBarLoad = "#2ab4c0";
export const DEFAULT_CHATVIEW_BACKGROUND = "#f5f7fb";
